module.exports = __webpack_public_path__ + "img/baloon1_sp.de56b463.svg";